import type { CSSProperties } from 'react';
import { getOutlineColor, getShapePath } from '../../core';
import { classNames } from '../../utils';

/** Outline width (px) of a shape. */
const DEFAULT_STROKE_WIDTH = 2;
/** Fill strength: slightly see-through, so edges behind a shape stay visible. */
const DEFAULT_FILL_OPACITY = 0.8;
const HALF = 0.5;

export type ShapeProps = {
  /** A `ShapeType`; unknown types draw as a rectangle. */
  type: string;
  width: number;
  height: number;
  /** Fill colour; the outline is the same colour, darker (D-033) — or grey for `transparent`. */
  color: string;
  outlineColor?: string;
  /** Outline width; 0 draws no outline. */
  strokeWidth?: number;
  /** SVG dash pattern for a dashed or dotted outline (e.g. `"12 6"`); solid when left out. */
  strokeDasharray?: string;
  fillOpacity?: number;
  className?: string;
  style?: CSSProperties;
};

/** A filled shape with a darker outline that exactly fills a `width` × `height` box (6.3, D-033). */
export const Shape = ({
  type,
  width,
  height,
  color,
  outlineColor,
  strokeWidth = DEFAULT_STROKE_WIDTH,
  strokeDasharray,
  fillOpacity = DEFAULT_FILL_OPACITY,
  className,
  style,
}: ShapeProps) => (
  <svg className={classNames('cm-shape', className)} width={width} height={height} style={style} aria-hidden="true">
    <path
      d={getShapePath(type, width, height, strokeWidth * HALF)}
      fill={color}
      fillOpacity={fillOpacity}
      stroke={outlineColor ?? getOutlineColor(color)}
      strokeWidth={strokeWidth}
      strokeDasharray={strokeDasharray}
      strokeLinejoin="round"
    />
  </svg>
);
